export const financeCatalog = {
  ingresos: {title:'Ingresos', type:'ING', concepto:true},
  egresos: {title:'Egresos', type:'EGR', concepto:true, presupuesto:true},
  gastos: {title:'Gastos', type:'EPG', concepto:true, presupuesto:true, proveedor:true},
  transferencias: {title:'Transferencias bancarias', type:'TRAN', transferencia:true},
};
export const localToday = () => { const d=new Date();return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; };
export function bankRate(id, currencies) {
  const main=currencies.find(m=>m.principal);
  if (!main) return null;
  if (String(main.id)===String(id)) return 1;
  const pair=main.tipos_cambio?.find(m=>String(m.id)===String(id));
  const rate=Number(pair?.pivot?.tipo_cambio);
  return Number.isFinite(rate)&&rate>0 ? rate : null;
}
export function transferRate(sourceId, destinationId, currencies) {
  if (String(sourceId)===String(destinationId)) return 1;
  const sourceRate=bankRate(sourceId,currencies);
  const destinationRate=bankRate(destinationId,currencies);
  return sourceRate&&destinationRate ? sourceRate/destinationRate : null;
}
export function changeBank(form, id, banks, currencies) {
  const bank=banks.find(b=>String(b.id)===String(id));
  return {...form,banco:id,destino:String(form.destino)===String(id)?'':form.destino,moneda:bank?.id_moneda||'',tipo_cambio:bankRate(bank?.id_moneda,currencies)??''};
}
export function validateFinance(kind,f) {
  const cfg=financeCatalog[kind];
  if (!f.documento || !f.banco || !f.fecha) return 'Selecciona documento, banco y fecha.';
  if (!Number.isFinite(Number(f.monto)) || Number(f.monto)<0 || f.monto==='') return 'Revisa el monto.';
  if (!(Number(f.tipo_cambio)>0)) return 'Configura el tipo de cambio de la moneda del banco.';
  if (cfg.proveedor && !f.proveedor) return 'Selecciona el proveedor.';
  if (cfg.concepto && !f.concepto) return 'Selecciona el concepto de presupuesto.';
  if (cfg.transferencia && (!f.destino || String(f.destino)===String(f.banco))) return 'Selecciona bancos de origen y destino distintos.';
  if (cfg.transferencia && !f.fecha_pago) return 'Selecciona la fecha de pago.';
  return '';
}
export function reportParams(f) {
  return {cargoabono:f.cargoabono,movimientos:f.movimientos,
    ...(f.fechas?{inicio:f.inicio,final:f.final}:{}),
    bancos:f.filtrarBancos?f.bancos:[],documentos:f.filtrarDocumentos?f.documentos:[],conceptos:f.filtrarConceptos?f.conceptos:[]};
}
export function reportRows(rows) {
  return rows.map(r=>({...r,documento_label:r.documento?`${r.folio}-${r.documento}`:'N/A',
    factura:r.documento_cobrado?`${r.folio_cobrado}-${r.documento_cobrado}`:r.documento_pagado?`${r.folio_pagado}-${r.documento_pagado}`:'N/A',
    cliente_proveedor:['A','Abono'].includes(r.tipo)?r.nombre_cliente||r.cliente_anticipo||'N/A':['C','Cargo'].includes(r.tipo)?r.nombre_proveedor||'N/A':'N/A'}));
}

export function financeColumns(kind) {
 const base=[['folio','Folio'],['documento','Documento'],['fecha','Fecha']];
 if(kind==='gastos')return [...base,['estatus','Estatus'],['proveedor','Proveedor'],['plazo_dias','Plazo'],['nombre_solicita','Persona que Solicita'],['segmento','Segmento de Negocio'],['empresa','Empresa'],['referencia','Referencia'],['iva','IVA'],['importe','Importe'],['moneda','Moneda'],['saldado','Saldado']];
 return [...base,['importe','Importe'],['moneda','Moneda'],...(kind==='transferencias'?[]:[['banco','Banco']]),...(['ingresos','egresos'].includes(kind)?[['concepto','Concepto']]:[]),['empresa','Empresa'],['referencia','Referencia']];
}
